import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  AlertController,
  LoadingController,
  ModalController,
  Platform,
} from '@ionic/angular';
import { isAfter, isBefore, isSameDay, lastDayOfMonth, startOfMonth, subMonths } from 'date-fns';
import { DevUtils } from 'src/providers/apiservices/Utils';
import { APIService } from 'src/providers/apiservices/apiservices';
import {
  GlobalService,
  ToastColors,
} from 'src/providers/apiservices/globalservices';
import { LocalStorageProvider } from 'src/providers/apiservices/localstorageprovider';
import { ComunicacaoProvider } from 'src/providers/comunicacao/comunicacao';
import { ContratoProvider } from 'src/providers/contrato/contrato';
import { EmpresaProvider } from 'src/providers/empresa/empresa';
import { OrigemProvider } from 'src/providers/origem/origem';
import { UsuarioMultiplanProvider } from 'src/providers/usuarios/usuariomultiplan';
import { UserConfigDto } from 'src/providersdata/UserConfigDto';
import { MessageComunicacaoPage } from '../message-comunicacao/message-comunicacao.page';
import {
  SelectSearchableItemPaginateApi,
  SelectSearchablePageApi,
} from '../select-searchable-api/select-searchable.page';
import { SelectSearchableItem, SelectSearchablePage } from '../select-searchable/select-searchable.page';
import { IacomunicacaoProvider } from 'src/providers/iacomunicacao/iacomunicacao';

interface GenericSelectOption {
  [key: string]: any;
  title: string;
  value: string;
  checked?: boolean;
}

interface ISegmento extends GenericSelectOption {
  idSegmento: string;
  desSegmento: string;
  cod_erro?: any;
  status_ret?: any;
  erro?: any;
  lojas: any[];
  lojas_search: any[];
}

interface IContratoDTO {
  idComunicacao?: null;
  numContrato?: string;
  idEmpresa?: string;
  StatusRespostaPromocao?: boolean;
  DataLimiteRespostaPromocao?: string | Date;
  FlgRespostaAceitaPromocao?: boolean;
  LoginUsuarioRespondeuPromocao?: string;
  NomeUsuarioRespondeuPromocao?: string;
  DataRespostaPromocao?: string | Date;
  GravarLeituraLojista?: boolean;
}

export enum IdTipoComunicado {
  Comunicado = 1,
  Notificação = 2,
  Solicitação = 3,
  Promoção = 4,
}

enum IdStatusComunicacaoTexto {
  EnvioNaoAnalisado = 1,
  EnvioAprovado = 2,
  EnvioRejeitado = 3,
}

enum IdTipoTexto {
  Criacao = 1,
  RejeicaoCriacao = 2,
  Resposta = 3,
  RejeicaoResposta = 4,
  JustificativaFinalizarProcesso = 5,
}

export enum StatusComunicacao {
  Analise = 0,
  Aprovado = 1,
  Rejeitado = 2,
}

@Component({
  selector: 'app-createcomunicado',
  templateUrl: './createcomunicado.page.html',
  styleUrls: ['./createcomunicado.page.scss'],
})
export class CreatecomunicadoPage implements OnInit, AfterViewInit {
  @Input() comunicadoId: any = null;
  @Input() isEdit: boolean = false;
  @Input() editNotifIndex: number = 0;
  @Input() taskId: string = '';
  @Input() tarefa: any = null;

  @ViewChild('InputFile') inputFile: ElementRef<HTMLInputElement>;
  @ViewChild('InputFile2') inputFile2: ElementRef<HTMLInputElement>;
  @ViewChild('InputFile3') inputFile3: ElementRef<HTMLInputElement>;

  @ViewChild('origem_selecionadaElement') origem_selecionadaElement: any;
  @ViewChild('tituloElement') tituloElement: any;
  @ViewChild('textoElement') textoElement: any;
  form_cadastro: FormGroup;
  configUser: UserConfigDto = new UserConfigDto(null);
  type = IdTipoComunicado.Comunicado;
  comunicacaoApiResponse: any = null;
  pickedDocuments = [];
  pickedDocuments2 = [];
  pickedDocuments3 = [];
  usuariosAd = [];

  n_segment = 'first';

  validation_messages = {
    texto: [{ type: 'required', message: 'Campo obrigatório.' }],
    titulo: [{ type: 'required', message: 'Campo obrigatório.' }],
    shopping_selecionado: [{ type: 'required', message: 'Campo obrigatório.' }],
    origem_selecionada: [{ type: 'required', message: 'Campo obrigatório.' }],
    aprovador_selecionado: [
      { type: 'required', message: 'Campo obrigatório.' },
    ],
    data_limite_solucao: [
      { type: 'required', message: 'Campo obrigatório.' },
      { type: 'validaDataLimite', message: 'Data inválida.' },
      { type: 'min', message: 'Data limite deve ser maior que a data atual.' },
    ],
    datafirst: [
      { type: 'required', message: 'Campo obrigatório.' },
      {
        type: 'dtNotificacaoInvalid',
        message: 'Data da 1ª notificação inválida.',
      },
      {
        type: 'dtNotificacaoMenorDtAtual',
        message: 'Data da 1ª notificação deve ser maior ou igual a data atual.',
      },
      {
        type: 'dtNotificacaoMenorDtLimiteSolucao',
        message:
          'Data da 1ª notificação deve ser menor ou igual a data limite de solução.',
      },
    ],
    datasecond: [
      { type: 'required', message: 'Campo obrigatório.' },
      {
        type: 'dtNotificacaoInvalid',
        message: 'Data da 2ª notificação inválida.',
      },
      {
        type: 'dtNotificacaoMenorDtNotificacao1',
        message:
          'Data da 2ª notificação deve ser maior que a data da 1ª notificação.',
      },
      {
        type: 'dtNotificacaoMenorDtLimiteSolucao',
        message:
          'Data da 2ª notificação deve ser menor ou igual a data limite de solução.',
      },
    ],
    datathird: [
      { type: 'required', message: 'Campo obrigatório.' },
      {
        type: 'dtNotificacaoInvalid',
        message: 'Data da 3ª notificação inválida.',
      },
      {
        type: 'dtNotificacaoMenorDtNotificacao2',
        message:
          'Data da 3ª notificação deve ser maior que a data da 2ª notificação.',
      },
      {
        type: 'dtNotificacaoMenorDtLimiteSolucao',
        message:
          'Data da 3ª notificação deve ser menor ou igual a data limite de solução.',
      },
    ],
  };

  hasNotification2 = false;
  hasNotification3 = false;
  notification2Enabled = false;
  notification3Enabled = false;
  datasNotificacao = {
    'first': '',
    'second': '',
    'third': ''
  }

  /**
   * YYYY-MM-DD
   */
  currentDate = new Date().toISOString().split('T')[0];

  //Criar comunicado
  shopping_selecionado: string = '';
  nome_shopping_selecionado: string = '';
  origem_selecionada: string = '';
  aprovador_selecionado: string = '';
  aprovador_selecionado_data: any = null;
  titulo: string = '';
  texto: string = '';
  textoOriginal: string = '';
  createdBy: any = null;

  isModalOriginalTextIA: boolean = false;

  idEmpresa: string = '';

  opennedAccordion: string = '';

  origin = [];

  malls: GenericSelectOption[] = [];

  stores: GenericSelectOption[] = [];
  storesSearch: GenericSelectOption[] = [];

  segmentos: ISegmento[] = [];

  nomeTipo: string = 'Comunicado';

  // Controle das checkboxes de lojas
  /**
   * @param key NumeroContrato
   * @param val Controle
   */
  storeCheckboxControls: { [key: string]: FormControl } = {};

  allStoresControls: {
    index: number;
    control: FormControl;
    store: GenericSelectOption;
  }[] = [];

  /**
   * Lojas selecionadas
   */
  get selectedLojas(): FormArray {
    return this.form_cadastro.get('lojas_selecionadas') as FormArray;
  }

  errorElements = {};

  usedIA = false;

  dataPromptAI = null

  isMobile: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private loadingController: LoadingController,
    private globalService: GlobalService,
    private formBuilder: FormBuilder,
    private contratoProvider: ContratoProvider,
    private empresaProvider: EmpresaProvider,
    private origemProvider: OrigemProvider,
    private comunicacaoProvider: ComunicacaoProvider,
    private usuarioMultiplanProvider: UsuarioMultiplanProvider,
    private providerLocalStorage: LocalStorageProvider,
    private AlertController: AlertController,
    private localStorageProvider: LocalStorageProvider,
    private iaComunicacaoProvider: IacomunicacaoProvider,
    private platform: Platform
  ) {}

  ngOnInit() {
    var usu = APIService.UsuarioLogado.Usuario;

    this.configUser = this.providerLocalStorage.getUserConfig(usu.login1 + '');

    if (this.platform.is('ios') || this.platform.is('android')) {
      this.isMobile = true;
    }

    var textoFormControl = new FormControl('');

    var dataLimiteResposta = new FormControl('');

    if (this.type == IdTipoComunicado.Solicitação) {
      textoFormControl = new FormControl(
        '',
        Validators.compose([Validators.required])
      );
    }

    var textofirst = new FormControl('');

    var datafirst = new FormControl(
      ''
    )
    var datasecond = new FormControl(
      ''
    )

    var datathird = new FormControl(
      ''
    )

    if(this.type == IdTipoComunicado.Notificação)
    {
      textofirst = new FormControl('', Validators.compose([Validators.required]));
      datafirst = new FormControl('', Validators.compose([Validators.required]));
      datasecond = new FormControl('', Validators.compose([this.validaDataNotificacao2()]));
      datathird = new FormControl('', Validators.compose([this.validaDataNotificacao3()]));
    }

    if (
      this.type == IdTipoComunicado.Solicitação ||
      this.type == IdTipoComunicado.Promoção
    ) {
      dataLimiteResposta = new FormControl(
        '',
        Validators.compose([
          Validators.required,
          this.dataLimiteSolucaoValidator,
        ])
      );
    }

    let aprovadorField = new FormControl('');

    if(this.isUsuarioLiberadoAprovacao != true)
    {
      aprovadorField = new FormControl('', Validators.compose([Validators.required]));
    }

    this.form_cadastro = this.formBuilder.group({
      textofirst: textofirst,
      datafirst: datafirst,

      textosecond: new FormControl('', Validators.compose([])),
      datasecond: datasecond,

      textothird: new FormControl('', Validators.compose([])),
      datathird: datathird,
      shopping_selecionado: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      lojas_selecionadas: this.formBuilder.array([]),
      titulo: new FormControl('', Validators.compose([Validators.required])),
      texto: textoFormControl,
      origem_selecionada: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      aprovador_selecionado: aprovadorField,
      data_limite_solucao: dataLimiteResposta,
      obrigar_anexo_lojista: new FormControl(false),
      enviar_alerta_email: new FormControl(false),
      obrigar_anexo_quero_participar: new FormControl(false),
      obrigar_anexo_nao_quero_participar: new FormControl(false),
    });

    // Carrega parâmetros
  }

  ngAfterViewInit() {
    this.carregarTela();
    this.errorElements['origem_selecionadaElement'] =
      this.origem_selecionadaElement.el;
    this.errorElements['tituloElement'] = this.tituloElement.el;
    this.errorElements['textoElement'] = this.textoElement.el;
  }

  // NOTIFICACAO
  notificationChange(event) {
    if (event.detail.value) this.n_segment = event.detail.value;
  }

  deleteNotificacao() {
    if (this.hasNotification3) {
      this.hasNotification3 = false;
      this.form_cadastro.get('datathird').setValue('');
      this.form_cadastro.get('textothird').setValue('');
      this.pickedDocuments3 = [];

      if (this.n_segment == 'third') {
        this.n_segment = 'second';
      }
    } else if (this.hasNotification2) {
      this.hasNotification2 = false;
      this.form_cadastro.get('datasecond').setValue('');
      this.form_cadastro.get('textosecond').setValue('');
      this.pickedDocuments2 = [];

      if (this.n_segment == 'second') {
        this.n_segment = 'first';
      }
    }
  }

  addNotification() {
    if (this.hasNotification2) {
      this.hasNotification3 = true;
      this.n_segment = 'third';

      if (this.notification2Enabled) {
        this.notification3Enabled = true;
        this.enableNotification('third');
      }
    } else {
      this.hasNotification2 = true;
      this.n_segment = 'second';

      this.notification2Enabled = true;
      this.enableNotification('second');
    }
  }

  enableNotification(n_segment: string) {
    if (n_segment == 'second' || n_segment == 'third') {
      let add =
        n_segment == 'second'
          ? this.notification2Enabled
          : this.notification3Enabled;

      if (add) {
        this.form_cadastro.controls['texto' + n_segment].addValidators(
          Validators.required
        );
        this.form_cadastro.controls['data' + n_segment].addValidators([
          Validators.required,
        ]);
      } else {
        this.form_cadastro.controls['texto' + n_segment].removeValidators(
          Validators.required
        );
        this.form_cadastro.controls['data' + n_segment].removeValidators(
          Validators.required
        );

        this.form_cadastro.controls['texto' + n_segment].setValue('');
        this.form_cadastro.controls['data' + n_segment].setValue('');

        if (n_segment == 'second') {
          this.notification3Enabled = false;
          this.enableNotification('third');
        }
      }

      this.form_cadastro.controls['texto' + n_segment].updateValueAndValidity();
      this.form_cadastro.controls['data' + n_segment].updateValueAndValidity();
    }
  }

  dataLimiteSolucaoValidator(
    control: AbstractControl
  ): ValidationErrors | null {
    const dtLimiteSolucaoTime = new Date(control.value).getTime();

    if (dtLimiteSolucaoTime < new Date().getTime()) {
      return { min: true };
    }

    return null;
  }

  validaDataNotificacao2(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

    if (!control.value) return null

    let _datanotificacao = control.value.split('T')[0];

    if (!DevUtils.DATE_YYYY_MM_DD_REGEX.test(_datanotificacao)) {
      return { dtNotificacaoInvalid: true };
    }
    _datanotificacao += 'T00:00:00';

    let dtNotificacao = new Date(_datanotificacao);

    let _datanotificacao1 = this.form_cadastro.get('datafirst').value.split('T')[0];
    if (!DevUtils.DATE_YYYY_MM_DD_REGEX.test(_datanotificacao1)) {
      return null;
    }

    _datanotificacao1 += 'T00:00:00';
    let dtNotificacao1 = new Date(_datanotificacao1);

    if (isBefore(dtNotificacao, dtNotificacao1) || isSameDay(dtNotificacao, dtNotificacao1)) {
      return { dtNotificacaoMenorDtNotificacao1: true };
    }

    let _dataLimiteSolucao = this.form_cadastro.get('data_limite_solucao')?.value

    if(_dataLimiteSolucao && DevUtils.DATE_YYYY_MM_DD_REGEX.test(_dataLimiteSolucao))
    {
      let dtLimiteSolucao = new Date(_dataLimiteSolucao + 'T00:00:00');

      if (isAfter(dtNotificacao, dtLimiteSolucao)) {
        return { dtNotificacaoMenorDtLimiteSolucao: true };
      }
    }

    return null;
  }
  }

  validaDataNotificacao3(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

    if (!control.value) return null;

    let _datanotificacao = control.value.split('T')[0];

    if (!DevUtils.DATE_YYYY_MM_DD_REGEX.test(_datanotificacao)) {
      return { dtNotificacaoInvalid: true };
    }

    _datanotificacao += 'T00:00:00';

    let dtNotificacao = new Date(_datanotificacao);
    let _datanotificacao2 = this.form_cadastro.get('datasecond').value.split('T')[0];
    if (!DevUtils.DATE_YYYY_MM_DD_REGEX.test(_datanotificacao2)) {
      return null;
    }
    _datanotificacao2 += 'T00:00:00';

    let dtNotificacao2 = new Date(_datanotificacao2);

    if(this.hasNotification2)
    {
      if (isBefore(dtNotificacao, dtNotificacao2) || isSameDay(dtNotificacao, dtNotificacao2)) {
        return { dtNotificacaoMenorDtNotificacao2: true };
      }
    }

    let _dataLimiteSolucao = this.form_cadastro.get('data_limite_solucao')?.value
    //console.log(_dataLimiteSolucao, dtNotificacao)

    if(_dataLimiteSolucao && DevUtils.DATE_YYYY_MM_DD_REGEX.test(_dataLimiteSolucao))
    {
      let dtLimiteSolucao = new Date(_dataLimiteSolucao + 'T00:00:00');

      if (isAfter(dtNotificacao, dtLimiteSolucao)) {
        return { dtNotificacaoMenorDtLimiteSolucao: true };
      }
    }



    return null;
  }
  }


  goToErroField() {
    if (this.form_cadastro.status == 'INVALID') {
      try {
        const errorsControlsEntries = Object.entries(
          this.form_cadastro.controls
        );

        const orderedControlList = [];

        const errorElementsEntries = Object.entries(this.errorElements);

        errorElementsEntries.forEach(([k, v]) => {
          let _key = k.replace('Element', '');

          if (this.form_cadastro.controls[_key]) {
            orderedControlList.push({
              key: k,
              value: this.form_cadastro.controls[_key],
              status: this.form_cadastro.controls[_key]?.status,
              element: v,
            });
          }
        });

        for (const currentElement of orderedControlList) {
          const { key, value, status, element } = currentElement;

          if (status == 'INVALID') {
            element.scrollIntoView();
            continue;
          }
        }
      } catch (error) {
        //console.log(error);
      }
    }
    //console.log('[ERROS]', this.form_cadastro, this.form_cadastro.errors);
  }

  getStoreControlIndex(numContrato: string) {
    const storeControlIndex = this.selectedLojas.controls.findIndex(
      (x, index) => {
        return this.stores[index].value == numContrato;
      }
    );

    return storeControlIndex;
  }

  /**
   * Variável temporária para filtrar as lojas
   */
  filteredStoreText = '';
  get selectedLojasControls() {
    if (!this.filteredStoreText) return this.selectedLojas.controls;

    const _storesControls = this.selectedLojas.controls.map(
      (control, index) => {
        const store = this.stores[index];

        return {
          index,
          store,
          control,
        };
      }
    );

    const onlyStores = _storesControls.map(({ store }, idx) => ({
      ...store,
      index: idx,
    }));

    const filteredStores = DevUtils.searchInArray(
      onlyStores,
      this.filteredStoreText,
      ['nomContrato', 'numContrato', 'lucLoja']
    );

    const unionFilteredStoresControls = filteredStores.map((store) => {
      const { index } = store;

      return _storesControls[index];
    });

    return unionFilteredStoresControls.map((c) => c.control);
  }

  getSelectedStores(): GenericSelectOption[] {
    const selectedValues = this.form_cadastro.value.lojas_selecionadas
      .map((checked, index) => (checked ? this.stores[index] : null))
      .filter((value) => value !== null);

    return selectedValues;
  }

  resetStoresFormArray(): void {
    this.selectedLojas.clear();
    this.allStoresControls = [];
    this.storeCheckboxControls = {};
  }

  addStoresToFormArray(): void {
    this.resetStoresFormArray();

    this.stores.forEach((option) => {
      const control = this.formBuilder.control(false);

      this.selectedLojas.push(control);
      this.storeCheckboxControls[option.value] = control; // Guardando o controle como numContrato como key.
    });

    if (
      this.isEdit &&
      this.comunicacaoApiResponse?.comunicacaoContratos?.length > 0
    ) {
      const contratos = this.comunicacaoApiResponse.comunicacaoContratos;

      // Alimentar a listagem do formulário "setando" os contratos que já foram selecionados
      contratos
        .filter((x) => x.contrato)
        .forEach(({ contrato }) => {
          const alreadySelectedStore = this.stores.find(
            (x) => x.numContrato == contrato.numContrato
          );

          if (alreadySelectedStore)
            this.setLojasCheckboxValue(alreadySelectedStore.numContrato, true);
        });
    }

    this.stores.forEach((store, index) => {
      this.allStoresControls.push({
        index,
        control: this.storeCheckboxControls[store.value],
        store,
      });
    });
  }

  setLojasCheckboxValue(numContrato: string, checked: boolean): void {
    const control = this.storeCheckboxControls[numContrato];

    if (control) {
      control.setValue(checked);
    }
  }

  async carregarTela() {
    try {
      switch (this.type) {
        case IdTipoComunicado.Comunicado:
          this.nomeTipo = 'Comunicado';
          break;
        case IdTipoComunicado.Promoção:
          this.nomeTipo = 'Promoção';
          break;
        case IdTipoComunicado.Solicitação:
          this.nomeTipo = 'Solicitação';
          break;
        case IdTipoComunicado.Notificação:
          this.nomeTipo = 'Notificação';
          break;
      }

      const origensPromise = this.carregarOrigem();
      const empresasPromise = this.carregarEmpresas();

      await Promise.all([empresasPromise, origensPromise]);

      if (this.isEdit) this.carregarComunicado();

      this.globalService.devlog(
        'Usuário logado: ',
        APIService.UsuarioLogado.Usuario
      );
    } catch (error) {
      console.error(error);
      this.dismiss();
    }
  }

  public get isUsuarioLiberadoAprovacao()
  {
    return APIService.UsuarioLogado.Usuario.isLiberadoAprovacao || false;
  }

  async carregarOrigem() {
    await this.origemProvider
      .get()
      .then((response) => {
        if (response.erro) {
          return this.globalService.publishToast({
            Mensagem: response.erro,
            Severidade: 2,
            Posicao: 'top',
          });
        }

        this.origin = response.Item.map((item) => {
          return {
            title: item.descricaoOrigem,
            value: item.idOrigem,
          };
        });
      })
      .catch((err) => {
        this.globalService.publishToast({
          Mensagem: err,
          Severidade: 2,
          Posicao: 'top',
        });
      });
  }

  async carregarComunicado() {
    this.globalService.devlog('Carregando comunicado: ', this.comunicadoId);
    const loading = await this.loadingController.create({
      message: 'Carregando comunicado...',
    });

    await loading.present();

    await this.comunicacaoProvider
      .getComunicadoById(this.comunicadoId, true)
      .then(async (res) => {
        this.globalService.devlog('Comunicado: ', res);

        if (res.erro) {
          //console.log('Erro: ', res.erro);
          this.globalService.publishToast({
            Mensagem: res.erro,
            Severidade: 2,
            Posicao: 'top',
          });
        } else {
          const response = res.Item;

          this.comunicacaoApiResponse = response;

          switch (response.idTipoComunicacao) {
            case IdTipoComunicado.Comunicado:
              this.nomeTipo = 'Comunicado';
              this.type = response.idTipoComunicacao;
              break;
            case IdTipoComunicado.Promoção:
              this.nomeTipo = 'Promoção';
              this.type = response.idTipoComunicacao;
              break;
            case IdTipoComunicado.Solicitação:
              this.nomeTipo = 'Solicitação';
              this.type = response.idTipoComunicacao;
              break;
            case IdTipoComunicado.Notificação:
              this.nomeTipo = 'Notificação';
              this.type = response.idTipoComunicacao;
              break;
          }

          if (
            response &&
            response.comunicacaoContratos &&
            response.comunicacaoContratos.length > 0
          ) {
            const contratos = response.comunicacaoContratos;
            this.shopping_selecionado = contratos[0].idEmpresa;

            if (this.type == IdTipoComunicado.Notificação) {
              await this.selecionarEmpresa(contratos[0].idEmpresa);
            }
            
            this.nome_shopping_selecionado = contratos[0].contrato?.idEmpresaNavigation?.nomEmpresa;
          }

          this.form_cadastro.controls['titulo'].setValue(response.titulo);

          const compararPorTextoDataEnvio = (a, b) => {
            const dataA = new Date(a.dataEnvioNotificacao).getTime();
            const dataB = new Date(b.dataEnvioNotificacao).getTime();

            return dataA - dataB;
          };

          if (Array.isArray(response.comunicacaoTextos)) {
            if (response.idTipoComunicacao == IdTipoComunicado.Notificação) {
              const textos = response.comunicacaoTextos.filter(txt => txt.idTipoTexto == 1 && txt.dataEnvioNotificacao != null);

              textos.sort(compararPorTextoDataEnvio);

              const notificacaoFormStructure = {
                0: 'first',
                1: 'second',
                2: 'third'
              }

              for (const [index, texto] of textos.entries()) {
                const fieldTextPath = `texto${notificacaoFormStructure[index]}`;
                const fieldDataPath = `data${notificacaoFormStructure[index]}`;
                this.form_cadastro.controls[fieldTextPath].setValue(texto.texto, {id: texto.idTexto});
                this.form_cadastro.get(fieldTextPath).updateValueAndValidity();

                this.form_cadastro.controls[fieldDataPath].setValue(texto.dataEnvioNotificacao.split("T")[0], {id: texto.idTexto});
                this.form_cadastro.get(fieldDataPath).updateValueAndValidity();
                this.datasNotificacao[notificacaoFormStructure[index]] = texto.dataEnvioNotificacao;
              }

              if (this.type == IdTipoComunicado.Notificação) {
                const fieldDataPathNotification = `data${notificacaoFormStructure[this.editNotifIndex]}`
                
                this.form_cadastro.controls[fieldDataPathNotification].setValue(new Date().toISOString().split("T")[0]);
                this.form_cadastro.get(fieldDataPathNotification).updateValueAndValidity();
              }

              if (textos.length >= 2) {
                this.hasNotification2 = true;
              }

              if (textos.length >= 3) {
                this.hasNotification3 = true;
              }
            }
            else
            {
              const creationText = response.comunicacaoTextos.find(
                (texto) => texto.idTipoTexto == 1
              );

              this.form_cadastro.controls['texto'].setValue(creationText?.texto || "", { id: creationText?.idTexto });

              this.texto = creationText?.texto || "";
            }
          }
          if (Array.isArray(response.comunicacaoArquivos)) {
            if (response.idTipoComunicacao == IdTipoComunicado.Notificação) {
              const textos = response.comunicacaoTextos.filter(txt => txt.idTipoTexto == 1 && txt.dataEnvioNotificacao != null);
              textos.sort(compararPorTextoDataEnvio);

              response.comunicacaoArquivos.forEach((arquivo) => {
                const { idArquivoNavigation } = arquivo;
                if (!idArquivoNavigation) return;
                if (idArquivoNavigation.flgAtivo != 1) return;

                const data = {
                  name: idArquivoNavigation.nomeArquivo,
                  ...idArquivoNavigation,
                }

                if (textos.length) {
                  let index = textos.findIndex(element => element.idTexto == arquivo.idTexto);

                  if (index == 0)
                    this.pickedDocuments.push(data);
                  else if (index == 1)
                    this.pickedDocuments2.push(data);
                  else if (index == 2)
                    this.pickedDocuments3.push(data);
                } else {
                  this.pickedDocuments.push(data);
                }
              });
            } else {
              // response.comunicacaoArquivos.forEach((arquivo) => {
              //   const { idArquivoNavigation } = arquivo;
              //   if (!idArquivoNavigation) return;
              //   if (idArquivoNavigation.flgAtivo != 1) return;

              //   this.pickedDocuments.push({
              //     name: idArquivoNavigation.nomeArquivo,
              //     ...idArquivoNavigation,
              //   });
              // });

              for (const arquivo of response.comunicacaoArquivos) {
                const { idArquivoNavigation } = arquivo;
                if (!idArquivoNavigation) return;
                if (idArquivoNavigation.flgAtivo != 1) return;

                let textos = response.comunicacaoTextos.filter(txt => txt.idTipoTexto == 1 && txt.dataEnvioNotificacao != null);

                textos.sort(compararPorTextoDataEnvio);

                if (textos[0] && arquivo.idTexto == textos[0]?.idTexto) {
                  this.pickedDocuments.push({
                    name: idArquivoNavigation.nomeArquivo,
                    ...idArquivoNavigation,
                  });
                }

                if (textos[1] && arquivo.idTexto == textos[1]?.idTexto) {
                  this.pickedDocuments2.push({
                    name: idArquivoNavigation.nomeArquivo,
                    ...idArquivoNavigation,
                  });
                }


                if (textos[2] && arquivo.idTexto == textos[2]?.idTexto) {
                  this.pickedDocuments3.push({
                    name: idArquivoNavigation.nomeArquivo,
                    ...idArquivoNavigation,
                  });
                }
              }
            }
          }

          this.form_cadastro.controls['enviar_alerta_email'].setValue(
            response.flgAlertaPorEmail
          );

          this.form_cadastro.controls['origem_selecionada'].setValue(
            response.idOrigem
          );

          this.form_cadastro.controls['aprovador_selecionado'].setValue(
            response.loginAprovador
          );

          if (
            response.dataLimiteResposta &&
            String(response.dataLimiteResposta).includes('T')
          ) {
            this.form_cadastro.controls['data_limite_solucao'].setValue(
              response.dataLimiteResposta.split('T')[0]
            );
          }

          this.form_cadastro.controls['obrigar_anexo_lojista'].setValue(
            response.flgAnexoResposta
          );

          this.form_cadastro.controls[
            'obrigar_anexo_quero_participar'
          ].setValue(response.flgAnexoRespostaPromocaoSim);

          this.form_cadastro.controls[
            'obrigar_anexo_nao_quero_participar'
          ].setValue(response.flgAnexoRespostaPromocaoNao);

          this.aprovador_selecionado = response.nomeAprovador;
          this.aprovador_selecionado_data = {
            nomUsuario: response.nomeAprovador,
            login1: response.loginAprovador,
          };

          this.createdBy = {
            name: response.nomeUsuarioCriacao,
            email: response.loginUsuarioCriacao,
          };

          this.form_cadastro.markAsDirty();
        }
      }).finally(() => {
        loading.dismiss();
      });
  }

  async getPromptAI() {
    this.trashIA();

    let origem = this.origin.find((x: any) => x.value == this.origem_selecionada);

    if (origem.title) {
      await this.iaComunicacaoProvider.get(this.type, origem.title).then((response) => {
        if (response?.status_ret != "NOK") {
          if (response.data.linhas > 0) {
            this.usedIA = true
            this.dataPromptAI = response.data.retorno[0];
          } else {
            this.usedIA = false
          }
        }
      });
    } else {
      this.usedIA = false
    }
  }

  removeHtmlTags(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  removeImgTags(html: string): string {
    return html.replace(/<img[^>]*>/g, '');
  }

  get postDataAI() {
    let origem = this.origin.find((x: any) => x.value == this.origem_selecionada);
    let shopping = this.malls.find((x: any) => x.value == this.shopping_selecionado);
    let textoFormatado = this.removeImgTags(this.texto);

    return {
      origem: origem.title,
      shopping: shopping.idEmpresa,
      nomeShopping: shopping.nomEmpresa,
      usuario: APIService.UsuarioLogado.Usuario.nomUsuario,
      tipocomunicacao: this.type,
      prompt: textoFormatado
    }
  }

  converteTagsIA(answer) {
    var textoFormatado = answer

    if (answer.includes("<%ORIGEM%>")  || answer.includes("&lt;%ORIGEM%&gt;")) {
      textoFormatado = textoFormatado.replace("<%ORIGEM%>", this.postDataAI.origem)
      textoFormatado = textoFormatado.replace("&lt;%ORIGEM%&gt;", this.postDataAI.origem)
    }

    if (answer.includes("<%DDMMYYYY%>") || answer.includes("&lt;%DDMMYYYY%&gt;")) {
      const data = new Date();
      const dia = String(data.getDate()).padStart(2, '0');
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const ano = data.getFullYear();

      textoFormatado = textoFormatado.replace("<%DDMMYYYY%>", `${dia}/${mes}/${ano}`)
      textoFormatado = textoFormatado.replace("&lt;%DDMMYYYY%&gt;", `${dia}/${mes}/${ano}`)
    }

    if (answer.includes("<%SHOPPING%>")  || answer.includes("&lt;%SHOPPING%&gt;")) {
      textoFormatado = textoFormatado.replace("<%SHOPPING%>", this.postDataAI.nomeShopping)
      textoFormatado = textoFormatado.replace("&lt;%SHOPPING%&gt;", this.postDataAI.nomeShopping)
    }
    
    if (answer.includes("<%USUARIO%>") || answer.includes("&lt;%USUARIO%&gt;")) {
      textoFormatado = textoFormatado.replace("<%USUARIO%>", this.postDataAI.usuario)
      textoFormatado = textoFormatado.replace("&lt;%USUARIO%&gt;", this.postDataAI.usuario)
    }

    return textoFormatado;
  }

  async useIA() {
    if(!this.shopping_selecionado) {
      return this.globalService.publishToast({
        Mensagem: 'É necessário selecionar o Shopping para revisar com IA.',
        Severidade: 2,
        Posicao: 'top',
      });
    }

    if(!this.texto) {
      return this.globalService.publishToast({
        Mensagem: 'É necessário preencher a descrição do comunicado para revisar com IA.',
        Severidade: 2,
        Posicao: 'top',
      });
    }

    let loading = await this.loadingController.create({
      message: 'Aguarde...',
    });
    loading.present();

    const dados = this.postDataAI;

    await this.iaComunicacaoProvider.requestAiReview(dados).then((response) => {
      if (response?.status_ret != "NOK") {
        if (response.data?.status_ret != "NOK") {
          this.textoOriginal = this.texto;
          this.texto = this.converteTagsIA(response.data.answer);

          this.seeOriginalTextIA();

          if (APIService.gAppInsights) {
            var dadosInsights: any = this.postDataAI;
            dadosInsights.mensagemOriginal = this.textoOriginal;
            dadosInsights.boxData = response.data.boxAiRequest;
            
            APIService.TelemetriaEventos(
              this.nomeTipo,
              "Request BoxAI",
              null,
              dadosInsights
            );

            dadosInsights.boxData = JSON.stringify(response.data);
            APIService.TelemetriaEventos(
              this.nomeTipo,
              "Response BoxAI",
              null,
              dadosInsights
            );
          }
        } else {
          return this.globalService.publishToast({
            Mensagem: 'Ocorreu um erro na revisão com IA. Tente novamente mais tarde.',
            Severidade: 2,
            Posicao: 'top',
          });
        }
      } else {
        return this.globalService.publishToast({
          Mensagem: response.erro || 'Ocorreu um erro na revisão com IA. Tente novamente mais tarde.',
          Severidade: 2,
          Posicao: 'top',
        });
      }
    }).catch((error: any) => {
      loading.dismiss();

      if (APIService.gAppInsights) {
        var dadosInsights: any = this.postDataAI;
        dadosInsights.mensagemOriginal = this.textoOriginal;
        dadosInsights.boxData = error?.error?.boxAiRequest;
        
        APIService.TelemetriaEventos(
          this.nomeTipo,
          "Request BoxAI",
          null,
          dadosInsights
        );

        dadosInsights.boxData = error?.error?.boxAiResponse;
        APIService.TelemetriaEventos(
          this.nomeTipo,
          "Response BoxAI",
          null,
          dadosInsights
        );
      }

      return this.globalService.publishToast({
        Mensagem: error?.error?.erro || 'Ocorreu um erro na revisão com IA. Tente novamente mais tarde.',
        Severidade: 2,
        Posicao: 'top',
      });
    }).finally(() => {
      loading.dismiss();
    });
  }

  trashIA() {
    if (this.textoOriginal) {
      this.texto = this.textoOriginal;
      this.textoOriginal = '';
    }

    this.isModalOriginalTextIA = false
  }

  seeOriginalTextIA() {
    this.isModalOriginalTextIA = true
  }

  async acceptRevisionIA() {
    // let loading = await this.loadingController.create({
    //   message: 'Aguarde...',
    // });
    // loading.present();

    if (APIService.gAppInsights) {
      var dados: any = this.postDataAI;
      dados.mensagemOriginal = this.textoOriginal;

      APIService.TelemetriaEventos(
        this.nomeTipo,
        "Confirmação Review BoxAI",
        null,
        dados
      );
    }

    this.isModalOriginalTextIA = false;

    // await this.iaComunicacaoProvider.saveReviewAcception(dados).then((response) => {
    //   if (response?.status_ret != "NOK") {
    //     this.isModalOriginalTextIA = false;
    //   }
    // }).finally(() => {
    //   loading.dismiss();
    // });
  }

  async showAviso(
    mensagem: string,
    cb: (isConfirm: boolean) => void = () => {}
  ) {
    const alert = await this.AlertController.create({
      header: 'Aviso',
      message: mensagem,
      backdropDismiss: false,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            cb(false);
          },
        },
        {
          text: 'Confirmar',
          role: 'confirm',
          handler: () => {
            cb(true);
          },
        },
      ],
    });

    await alert.present();
  }

  async carregarEmpresas() {
    try {
      const response = await this.empresaProvider.get('');

      if(response.erro)
      {
        console.error(response.erro);
        return this.globalService.publishToast({
          Mensagem: response.erro,
          Severidade: 2,
          Posicao: 'top',
        });
      }


      var usu = APIService.UsuarioLogado.Usuario;
      const isTodsEmpresas = usu.contratoLoginPerfils.find(
        (x) =>
          x.idEmpresa.startsWith('TODS') || x.idEmpresa.startsWith('TODOS')
      )
        ? true
        : false;

      if (isTodsEmpresas) {
        // Tem acesso a todas empresas;
        this.malls = response.Item.map((item) => {
          return {
            ...item,
            title: item.nomEmpresa,
            value: item.idEmpresa,
          };
        });
      } else {
        const empresas =
          usu.contratoLoginPerfils?.map((x) => x.idEmpresa) || [];

        this.malls = response.Item.filter((x) =>
          empresas.includes(x.idEmpresa)
        ).map((item) => {
          return {
            ...item,
            title: item.nomEmpresa,
            value: item.idEmpresa,
          };
        });
      }

      if (!this.isEdit) {
        if(this.configUser.shoppingCod)
        {
          const autoSelectMall = this.malls.find(
            (x) => x.value == this.configUser.shoppingCod
          );

          this.shopping_selecionado = autoSelectMall?.idEmpresa;
        }
      }
    } catch (error) {
      console.error(error);
      this.globalService.publishToast({
        Mensagem: error.erro,
        Severidade: 2,
        Posicao: 'top',
      });
    }
  }

  async openShoppingsModal() {
    let listaFiltro: Array<SelectSearchableItem> = [];

    let lista: Array<SelectSearchableItem> = this.malls.map((empresa) => {
      return new SelectSearchableItem(
        empresa.idEmpresa,
        empresa.nomEmpresa,
        empresa
      );
    });

    let currentSelectedMall = this.malls.find(
      (mall) =>
        mall.idEmpresa == this.form_cadastro.get('shopping_selecionado').value
    );

    if (currentSelectedMall && currentSelectedMall.title) {
      listaFiltro.push(
        new SelectSearchableItem(
          currentSelectedMall.value,
          currentSelectedMall.title,
          currentSelectedMall
        )
      );
    }

    const modal = await this.modalCtrl.create({
      component: SelectSearchablePage,
      componentProps: {
        titulo: 'Selecione a empresa',
        filtro: '',
        lista: lista,
        maxsize: 1,
        selecionados: listaFiltro,
      },
      cssClass: 'modal-edicao',
      backdropDismiss: false,
    });

    modal.onDidDismiss().then(async (ret) => {
      if (ret.data && ret.data.salvar) {
        for (let i = 0; i < ret.data.selecionados.length; i++) {
          await this.selecionarEmpresa(ret.data.selecionados[i].id);
          this.nome_shopping_selecionado = ret.data.selecionados[i].texto;
        }
      }
    });

    //load.dismiss();
    await modal.present();
  }

  async openLojasModal() {
    let listaFiltro: Array<SelectSearchableItem> = [];

    let lista: Array<SelectSearchableItem> = this.stores.map((loja) => {
      return new SelectSearchableItem(
        loja.numContrato,
        `${loja.nomContrato} (${loja.lucLoja} - ${loja.numContrato})`,
        loja
      );
    });

    let currentSelectedStore = null
    let selectedStore = this.getSelectedStores()[0]

    if(selectedStore) {
      currentSelectedStore = this.stores.find(
        (store) =>
          store.numContrato == selectedStore.numContrato
      );
    }

    if (currentSelectedStore && currentSelectedStore.title) {
      listaFiltro.push(
        new SelectSearchableItem(
          currentSelectedStore.value,
          `${currentSelectedStore.title}`,
          currentSelectedStore
        )
      );
    }

    const modal = await this.modalCtrl.create({
      component: SelectSearchablePage,
      componentProps: {
        titulo: 'Lojas de ' + this.nome_shopping_selecionado,
        filtro: '',
        lista: lista,
        maxsize: 1,
        selecionados: listaFiltro,
      },
      cssClass: 'modal-edicao',
      backdropDismiss: false,
    });

    modal.onDidDismiss().then((ret) => {
      if (ret.data && ret.data.salvar) {
        for (let i = 0; i < ret.data.selecionados.length; i++) {
          let currentStore = this.getSelectedStores()[0];
          if(currentStore){
            this.setLojasCheckboxValue(currentStore.value, false)
          }

          this.setLojasCheckboxValue(ret.data.selecionados[i].id, true);
        }
      }
    });

    //load.dismiss();
    await modal.present();
  }

  getSelectedStoresBySegmento(sg: ISegmento) {
    if (!sg) return;

    const { idSegmento } = sg;

    return this.getSelectedStores()
      .filter((x) => x)
      .filter((store) => {
        if (store.idSegmento == idSegmento) {
          return true;
        } else if (
          Array.isArray(store.idSegmentos) &&
          store.idSegmentos.find((x) => x.idSegmento == idSegmento)
        ) {
          return true;
        } else {
          return false;
        }
      }).length;
  }
  get allSelectedStoresLength() {
    return this.getSelectedStores().length;
  }

  capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  searchLojaSegmento(segmento: ISegmento, $event: any) {
    // //console.log(segmento, $event.target.value)

    const segmentoEditIdx = this.segmentos.findIndex(
      (sg) => sg.idSegmento === segmento.idSegmento
    );

    // //console.log(DevUtils.searchInArray(
    //   segmento.stores,
    //   $event.target.value,
    //   ['nomContrato', 'numContrato']
    // ))

    if ($event.target.value)
      this.segmentos[segmentoEditIdx].lojas_search = DevUtils.searchInArray(
        segmento.stores,
        $event.target.value,
        ['nomContrato', 'numContrato']
      );
    else
      this.segmentos[segmentoEditIdx].lojas_search =
        this.segmentos[segmentoEditIdx].stores;
  }

  searchLojaTodas($event: any) {
    if ($event.target.value) {
      const stores = this.allStoresControls.map((x) => x.store);

      let filtered = DevUtils.searchInArray(
        stores,
        $event.target.value,
        ['nomContrato', 'numContrato']
      );

        this.allStoresControls = filtered.map((store) => {
          const storeIndex = this.stores.findIndex(x => x.value == store.value);

          return {
            index: storeIndex,
            control: this.storeCheckboxControls[store.value],
            store,
          };
        })
    } else {
      this.allStoresControls = this.stores.map((store, index) => {
        return {
          index,
          control: this.storeCheckboxControls[store.value],
          store,
        };
      });
    }
  }

  async onPreview(id, type) {
    if (!this.origem_selecionada || !this.titulo) {
      this.globalService.publishToast({
        Mensagem: 'Preencha todos os campos',
        Severidade: 2,
        Posicao: 'top',
      });
      return;
    }

    // if ((Number(this.type) != 4 || Number(this.type) != 1) && !this.texto) {
    //   this.globalService.publishToast({
    //     Mensagem: 'Preencha todos os campos',
    //     Severidade: 2,
    //     Posicao: 'top',
    //   });
    //   return;
    // }

    var usu = APIService.UsuarioLogado.Usuario;
    let origem = {
      idOrigem: null,
      descricaoOrigem: ""
    };

    if (this.origem_selecionada) {
      let _origem = this.origin.find((x: any) => x.value == this.origem_selecionada);
      origem = {
        idOrigem: _origem.value,
        descricaoOrigem: _origem.title,
      };
    }

    const comunicacaoArquivos = this.pickedDocuments.map((file, index) => {
      return {
        idTexto: index + 1,
        idArquivo: null,
        idArquivoNavigation: {
          idGestorDocumentos: null,
          nomeArquivo: file.name,
        },
      };
    });

    const comunicado = {
      sender: this.origin.find((x: any) => x.value == this.origem_selecionada)
        .title,
      titulo: this.titulo,
      date: new Date(),
      nomeUsuarioCriacao: usu.nomUsuario,
      loginUsuarioCriacao: usu.login1,
      nomeAprovador: this.aprovador_selecionado_data?.nomUsuario || null,
      loginAprovador: this.aprovador_selecionado_data?.login1 || null,
      comunicacaoLeituras: [],
      comunicacaoTextos: [
        {
          dataCriacao: new Date(),
          message: this.texto,
          idTipoTexto: 1,
        },
      ],
      comunicacaoArquivos: comunicacaoArquivos,
      comunicacaoContratos: this.getSelectedStores(),
      dataComunicacao: new Date(),
      idOrigemNavigation: origem,
      idTipoComunicacao: this.type,
      contratosPreview: this.getSelectedStores(),
      dataLimiteResposta:
        this.type == IdTipoComunicado.Solicitação ||
        this.type == IdTipoComunicado.Promoção
          ? this.form_cadastro.get('data_limite_solucao').value
          : null,
      approvedBy: {
        name: this.aprovador_selecionado_data?.nomUsuario || null,
        email: this.aprovador_selecionado_data?.login1 || null,
      },
      createdBy: {
        name: this.createdBy ? this.createdBy.name : usu.nomUsuario,
        email: this.createdBy ? this.createdBy.email : usu.email,
      },
    };

    const modal = await this.modalCtrl.create({
      component: MessageComunicacaoPage,
      cssClass: 'bigModal',
      componentProps: { idComunicacao: id, type: this.type, bdComunicacaoData: comunicado, isPreview: true },
    });
    modal.present();
  }

  async showSucessoCriacao() {
    const alert = await this.AlertController.create({
      header: 'Sucesso!',
      message: `${this.nomeTipo} ${
        this.isEdit
          ? this.nomeTipo == 'Comunicado'
            ? 'editado'
            : 'editada'
          : this.nomeTipo == 'Comunicado'
          ? 'criado'
          : 'criada'
      } com sucesso.`,
      buttons: [
        {
          text: 'Confirmar',
          role: 'confirm',
          handler: () => {
            // this.dismiss();
          },
        },
      ],
    });

    await alert.present();
  }

  ignorarAvisoUmaLoja: boolean = false;
  async onEnviar() {
    var usu = APIService.UsuarioLogado.Usuario;

    if (this.form_cadastro.valid) {
      let loading = await this.globalService.showLoading({message: `${this.isEdit ? 'Atualizando' : 'Criando'} ${this.nomeTipo}...`});

      const stores: IContratoDTO[] = this.getSelectedStores().map((store) => {
        return {
          numContrato: store.numContrato,
          idEmpresa: store.idEmpresa,
          GravarLeituraLojista: true,
        };
      });

      if (stores.length === 0) {
        loading.dismiss();
        return this.globalService.showAviso(
          'Selecione ao menos uma loja para continuar.'
        );
      }

      if (
        this.ignorarAvisoUmaLoja === false &&
        this.type == IdTipoComunicado.Comunicado &&
        stores.length == 1
        && this.isEdit == false
      ) {
        await loading.dismiss();
        const isConfirm = await this.globalService.showAviso(
          'Você selecionou apenas uma loja, não seria melhor enviar uma solicitação ?'
        );

        if (isConfirm) {
          // Troca o tipo de comunicado para solicitação
          this.type = IdTipoComunicado.Solicitação;
          this.nomeTipo = 'Solicitação';
          this.form_cadastro.controls["data_limite_solucao"].setValidators([
            Validators.required,
            this.dataLimiteSolucaoValidator
          ]);
          this.form_cadastro.controls["data_limite_solucao"].updateValueAndValidity();

          this.getPromptAI();

          return;
        } else {
          loading = await this.globalService.showLoading({
            message: `Criando ${this.nomeTipo}...`,
          });
        }
      }

      // //console.log(this.aprovador_selecionado_data, "STORES", this.selectedStores);

      const postFiles = [];

      for await (const file of this.pickedDocuments) {
        if (file.idGestorDocumentos) continue;

        try {
          const base64 = await DevUtils.fileToBase64(file);

          postFiles.push({
            base64,
            fileName: file.name,
            indexNotificacao: 0
          });
        } catch (error) {
          //console.log(error);
        }
      }

      for await (const file of this.pickedDocuments2) {
        if (file.idGestorDocumentos) continue;

        try {
          const base64 = await DevUtils.fileToBase64(file);

          postFiles.push({
            base64,
            fileName: file.name,
            indexNotificacao: 1
          });
        } catch (error) {
          //console.log(error);
        }
      }

      for await (const file of this.pickedDocuments3) {
        if (file.idGestorDocumentos) continue;

        try {
          const base64 = await DevUtils.fileToBase64(file);

          postFiles.push({
            base64,
            fileName: file.name,
            indexNotificacao: 2
          });
        } catch (error) {
          //console.log(error);
        }
      }

      const obrigar_anexo_quero_participar = this.form_cadastro.get(
        'obrigar_anexo_quero_participar'
      ).value;
      const obrigar_anexo_nao_quero_participar = this.form_cadastro.get(
        'obrigar_anexo_nao_quero_participar'
      ).value;

      const getTextos = () => {
        if(this.type == IdTipoComunicado.Notificação)
        {
          const _textos = [];

          const textoFirst = this.form_cadastro.get("textofirst")?.value
          if(textoFirst)
          {
            _textos.push({
              IdTexto: this.form_cadastro.get("textofirst").get('id') || null,
              IdTipoTexto: IdTipoTexto.Criacao,
              Texto: textoFirst,
              DataEnvioNotificacao: this.form_cadastro.get("datafirst").value,
              IdStatusComunicacaoTexto: IdStatusComunicacaoTexto.EnvioNaoAnalisado
            })
          }

          const textoSecond = this.form_cadastro.get("textosecond")?.value
          if(textoSecond)
          {
            _textos.push({
              IdTexto: this.form_cadastro.get("textosecond").get('id') || null,
              IdTipoTexto: IdTipoTexto.Criacao,
              Texto: textoSecond,
              DataEnvioNotificacao: this.form_cadastro.get("datasecond").value,
              IdStatusComunicacaoTexto: IdStatusComunicacaoTexto.EnvioNaoAnalisado
            })
          }

          const textoThird = this.form_cadastro.get("textothird")?.value
          if(textoThird)
          {
            _textos.push({
              IdTexto: this.form_cadastro.get("textothird").get('id') || null,
              IdTipoTexto: IdTipoTexto.Criacao,
              Texto: textoThird,
              DataEnvioNotificacao: this.form_cadastro.get("datathird").value,
              IdStatusComunicacaoTexto: IdStatusComunicacaoTexto.EnvioNaoAnalisado
            })
          }

          return _textos;
        }

        const _texto = this.comunicacaoApiResponse?.comunicacaoTextos.find(
          (texto) => texto.idTipoTexto == 1
        );

        return [

          // Comunicação, Solicitação, Promoção enviam apenas 1 texto.
          {
            IdTexto: _texto ? _texto.idTexto : null,
            IdTipoTexto: IdTipoTexto.Criacao,
            Texto: this.texto,
            DataEnvioNotificacao: new Date().toISOString(),
            IdStatusComunicacaoTexto:
              IdStatusComunicacaoTexto.EnvioNaoAnalisado,
          },

        ]
      }

      const postData = {
        ...(this.comunicadoId && { IdComunicacao: this.comunicadoId }),
        idOrigem: this.origem_selecionada,
        loginUsuarioCriacao: usu.login1,
        ComunicacaoContratos: stores,
        ComunicacaoTextos: getTextos(),
        ComunicacaoArquivos: [],
        Arquivos: postFiles,
        idTipoComunicacao: this.type,
        comunicadoTipo: this.type == IdTipoComunicado.Promoção ? 'I' : 'T',
        dataComunicacao: new Date().toISOString(),
        flgAlertaPorEmail: this.form_cadastro.get('enviar_alerta_email').value || false,
        flgAnexoResposta: this.form_cadastro.get('obrigar_anexo_lojista').value || false,
        FlgAnexoRespostaPromocaoSim: obrigar_anexo_quero_participar,
        FlgAnexoRespostaPromocaoNao: obrigar_anexo_nao_quero_participar,
        nomeUsuarioCriacao: usu.nomUsuario,
        titulo: this.titulo,
        data_limite_resposta:
          this.type == IdTipoComunicado.Solicitação ||
          this.type == IdTipoComunicado.Promoção ||
          this.type == IdTipoComunicado.Notificação
            ? new Date(
                this.form_cadastro.get('data_limite_solucao').value +
                  ' 00:00:00'
              )
            : null,
        dataLimiteResposta:
          this.type == IdTipoComunicado.Solicitação ||
          this.type == IdTipoComunicado.Promoção ||
          this.type == IdTipoComunicado.Notificação
            ? new Date(
                this.form_cadastro.get('data_limite_solucao').value +
                  ' 00:00:00'
              )
            : null,
        nomeAprovador: this.aprovador_selecionado_data?.nomUsuario, //Fazer um get para buscar os usuários multiplan/admin do sistema para selecionar aqui
        loginAprovador: this.aprovador_selecionado_data?.login1, // Fazer um get para buscar os usuários multiplan/admin do sistema para selecionar aqui
      };

      if (
        this.comunicacaoApiResponse?.comunicacaoTextos &&
        this.comunicacaoApiResponse.comunicacaoTextos.length > 0
      ) {
        var comunicacaoTextosFiltered = this.comunicacaoApiResponse.comunicacaoTextos.filter(item => item.idTipoTexto == 1);
        
        if (comunicacaoTextosFiltered.length > 0) {
          postData.ComunicacaoTextos[0].IdTexto = comunicacaoTextosFiltered[0].idTexto;
        }

        if (comunicacaoTextosFiltered.length > 1) {
          postData.ComunicacaoTextos[1].IdTexto = comunicacaoTextosFiltered[1].idTexto;
        }

        if (comunicacaoTextosFiltered.length > 2) {
          postData.ComunicacaoTextos[2].IdTexto = comunicacaoTextosFiltered[2].idTexto;
        }
      }

      this.globalService.devlog(
        'ComunicacaoApiResponse',
        this.comunicacaoApiResponse
      );

      this.globalService.devlog('PostDATA', postData);

      let commParams = {};

      if (
        typeof this.tarefa?.taD_DISPLAY_NAME === 'string' &&
        this.tarefa.taD_DISPLAY_NAME.includes('Ajustar')
      ) {
        if (this.taskId) {
          commParams['taskIdBPM'] = this.taskId;
        }
      }

      this.comunicacaoProvider
        .add(postData, commParams)
        .then((response) => {
          this.globalService.devlog('Createcomunicado', response);

          if (response && response.erro) {
            this.globalService.publishToast({
              Mensagem: `Não foi possível ${
                this.isEdit ? 'editar' : 'criar'
              } o comunicado.`,
              Severidade: 2,
              Posicao: 'top',
            });
          } else {

            this.showSucessoCriacao();

            let responseDismiss = {}

            responseDismiss['editado'] = this.isEdit ? true : false;
            responseDismiss['criado'] = this.isEdit ? false : true;
            this.dismiss(responseDismiss);
          }
        })
        .catch((err) => {
          return this.globalService.presentToast(
            'Erro ao criar comunicado',
            ToastColors.danger
          );
        })
        .finally(() => {
          loading.dismiss();
        });
    } else {
      this.globalService.devlog(
        'Createcomunicado',
        'form invalido',
        this.form_cadastro
      );
      this.validateAllFormFields(this.form_cadastro);
    }
    this.goToErroField();
  }

  async setSegmentoAberto(event: any) {
    const idSegmento = event.detail ? event.detail.value : null;

    if (event.target && event.target.innerHTML.startsWith('<input')) return;

    if (idSegmento == 'todas') this.opennedAccordion = idSegmento;

    if (!idSegmento || idSegmento === 'todas' || idSegmento === 'on') return;

    this.opennedAccordion = idSegmento;
  }

  selectTodasLojas(e) {
    // Se todas já estiverem selecionadas, tira a seleção

    // const isSelectAll = new PowerArray<FormArray>(this.selectedLojas.controls).all(control => control.value === true) ? false : true;

    const isSelectAllStore = this.selectedLojas.controls.every(
      (control) => control.value === true
    )
      ? false
      : true;

    this.selectedLojas.controls.forEach((control) => {
      control.setValue(isSelectAllStore);
    });
  }

  get isAllStoresSelected()
  {
    return this.selectedLojas.controls.every(
      (control) => control.value === true
    );
  }

  selectSegmentLojas(segmento: ISegmento) {
    const { stores } = segmento;

    const controlsStoresSegmento = stores.map(
      (store) => this.storeCheckboxControls[store.numContrato]
    ) as Array<FormControl>;

    const isAllSegmentStoresSelected = controlsStoresSegmento.every(
      (control) => control.value == true
    );

    for (const storeSeg of stores) {
      const storeControl = this.storeCheckboxControls[storeSeg.numContrato];

      if (storeControl) {
        if (controlsStoresSegmento.length == 0) {
          storeControl.setValue(true);
          continue;
        }

        storeControl.setValue(isAllSegmentStoresSelected ? false : true);
      }
    }
  }

  getSegmentDocumentWorking(n_segment = null)
  {
    if (!n_segment) return { _documentsPick: this.pickedDocuments, _input: this.inputFile }

    if(n_segment == 'first')
      return {_documentsPick: this.pickedDocuments, _input: this.inputFile}
    else if(n_segment == 'second')
      return {_documentsPick: this.pickedDocuments2, _input: this.inputFile2}
    else
      return {_documentsPick: this.pickedDocuments3, _input: this.inputFile3}
  }

  setDocumentBySegmentWorking(n_segment = null, newArray = [])
  {
    if (!n_segment) return this.pickedDocuments = newArray;

    if(n_segment == 'first')
      return this.pickedDocuments = newArray;
    else if(n_segment == 'second')
      return this.pickedDocuments2 = newArray;
    else if(n_segment == 'third')
      return this.pickedDocuments3 = newArray;
    else
      return this.pickedDocuments = newArray;
  }

  async onPickFile(n_segment = null) {
    let {_documentsPick, _input} = this.getSegmentDocumentWorking(n_segment);

    if (_documentsPick.length === 5) {
      alert('Limite de arquivos atingido');
      return;
    }

    _input?.nativeElement.click();
  }

  async addFile($event, n_segment = null) {
    let {_documentsPick, _input} = this.getSegmentDocumentWorking(n_segment);

    const file = _input?.nativeElement.files[0];

    const TEN_MB_IN_BYTES = 10000000;

    if (file.size > TEN_MB_IN_BYTES) {
      alert('Arquivo muito grande');
      return;
    }

    _documentsPick = _documentsPick.concat(file);

    this.setDocumentBySegmentWorking(n_segment, _documentsPick);
  }

  mAguarde = '';
  async selecionarEmpresa(event = null) {
    if (!event) return;

    if(IdTipoComunicado.Notificação == this.type)
      this.form_cadastro.controls['shopping_selecionado'].setValue(event);

    this.globalService.devlog('Loading empresa', event);

    this.mAguarde = 'carregando...';

    var mallObj = this.malls.find(mall => mall.idEmpresa == event);

    await this.contratoProvider
      .getContratoSegmentos(event)
      .then((response: any) => {
        this.mAguarde = '';
        if (response.Item) {
          this.stores = [];
          if(this.isEdit == false)
          {
            this.aprovador_selecionado = "";
            this.aprovador_selecionado_data = null;
          }
          let usu = APIService.UsuarioLogado.Usuario;

          const isTodsEmpresas = usu.contratoLoginPerfils.find(
            (x) =>
              x.idEmpresa.startsWith('TODS') || x.idEmpresa === 'TODOS_TODS'
          )
            ? true
            : false;
          const isTodsContratos = usu.contratoLoginPerfils.find(
            (x) =>
              x.numContrato.startsWith('TODS') ||
              x.numContrato.startsWith('TODOS')
          )
            ? true
            : false;

          let _segmentos = [];

          response.Item.flatMap((item) => item.idSegmentos).forEach((item) => {
            if (_segmentos.find((x) => x.idSegmento == item.idSegmento)) {
              return;
            }

            _segmentos.push({
              title: item.desSegmento,
              value: item.idSegmento,
              idSegmento: item.idSegmento,
              desSegmento: item.desSegmento,
            });
          });

          let configUser = this.localStorageProvider.getUserConfig(
            APIService.UsuarioLogado.Usuario.login1
          );
          
          var lastDayOfPastMonth = lastDayOfMonth(subMonths(new Date(), 1));
          var primeiroDiaDoMesAtual = startOfMonth(new Date());
          if (configUser.isUsuarioMultiplan) {
            this.stores = response.Item.filter(store => store.dtRescisao == null || new Date(store.dtRescisao) >= primeiroDiaDoMesAtual || new Date(store.dtRescisao) >= new Date(mallObj?.dtAberturaAdm))
          } else {
            this.stores = response.Item.filter(store => store.dtRescisao == null || new Date(store.dtRescisao) >= primeiroDiaDoMesAtual || new Date(store.dtRescisao) >= new Date(mallObj?.dtAberturaLoja))
          }

          this.segmentos = _segmentos.map((segmento) => {
            return {
              ...segmento,
              stores: this.stores.filter((x) =>
                x.idSegmentos.find((y) => y.idSegmento == segmento.idSegmento)
              ),
              lojas_search: this.stores.filter((x) =>
                x.idSegmentos.find((y) => y.idSegmento == segmento.idSegmento)
              ),
            };
          });

          if (isTodsEmpresas && isTodsContratos) {
            this.stores = this.stores.map((item) => {
              return {
                ...item,
                title: `${item.nomContrato} (${item.lucLoja} - ${item.numContrato})`,
                value: item.numContrato,
                segmento:
                  item.idSegmentos[0] == undefined ? null : item.idSegmentos[0],
                idSegmento:
                  item.idSegmentos[0] == undefined
                    ? null
                    : item.idSegmentos[0]['idSegmento'],
              };
            });
          } else if (!isTodsEmpresas && isTodsContratos) {
            this.stores = this.stores.filter(
              (store) => store.numContrato
            ).map((item) => {
              return {
                ...item,
                title: `${item.nomContrato} (${item.lucLoja} - ${item.numContrato})`,
                value: item.numContrato,
                segmento:
                  item.idSegmentos[0] == undefined ? null : item.idSegmentos[0],
                idSegmento:
                  item.idSegmentos[0] == undefined
                    ? null
                    : item.idSegmentos[0]['idSegmento'],
              };
            });
          } else {
            const contratosByShoppingSelecionado =
              usu.contratoLoginPerfils.filter(
                (x) => x.idEmpresa == this.shopping_selecionado
              );

            this.stores = this.stores.filter((store) =>
              contratosByShoppingSelecionado.find(
                (x) => x.numContrato == store.numContrato
              )
            ).map((item) => {
              return {
                ...item,
                title: `${item.nomContrato} (${item.lucLoja} - ${item.numContrato})`,
                value: item.numContrato,
                segmento:
                  item.idSegmentos[0] == undefined ? null : item.idSegmentos[0],
                idSegmento:
                  item.idSegmentos[0] == undefined
                    ? null
                    : item.idSegmentos[0]['idSegmento'],
              };
            });
          }

          this.addStoresToFormArray();
        } else {
          this.globalService.publishToast({
            Mensagem: response.erro,
            Severidade: 2,
            Posicao: 'top',
          });
        }
      })
      .catch((error: any) => {
        this.globalService.publishToast({
          Mensagem: error.erro,
          Severidade: 2,
          Posicao: 'top',
        });
        //loading.dismiss();
      })
      .finally(() => {
        this.mAguarde = '';
      });
  }

  async removeFile(index: number, n_segment = null) {
    let {_documentsPick} = this.getSegmentDocumentWorking(n_segment);

    if (this.isEdit) {
      this.showAviso(
        'Este processo é irreversível, tem certeza que deseja apagar o arquivo?',
        async (isConfirm) => {
          if (!isConfirm || !_documentsPick[index])
            return;

          if(!_documentsPick[index].idArquivo)
          {
            _documentsPick.splice(index, 1);
            return;
          }

          let loading = await this.loadingController.create({
            message: 'Aguarde...',
          });
          loading.present();


          this.comunicacaoProvider
            .deleteFiles(_documentsPick[index].idArquivo)
            .then((response: any) => {
              if (response.Item) {
                this.globalService.devlog('RemoçãoArquivo', response);
                _documentsPick.splice(index, 1);
              }
            })
            .catch((error: any) => {
              this.globalService.publishToast({
                Mensagem: error.erro,
                Severidade: 2,
                Posicao: 'top',
              });
            })
            .finally(() => {
              loading.dismiss();
            });
        }
      );
    } else {
      _documentsPick.splice(index, 1);
    }


    this.setDocumentBySegmentWorking(n_segment, _documentsPick);
  }

  get tipoAtividade() {
    switch (this.type) {
      case IdTipoComunicado.Comunicado:
        return APIService.ID_ATIVIDADES.CRIAR_COMUNICADO;
      case IdTipoComunicado.Promoção:
        return APIService.ID_ATIVIDADES.CRIAR_PROMOCAO;
      case IdTipoComunicado.Solicitação:
        return APIService.ID_ATIVIDADES.CRIAR_SOLICITAÇÃO;
      case IdTipoComunicado.Notificação:
        return APIService.ID_ATIVIDADES.CRIAR_NOTIFICACAO;
      default:
        return APIService.ID_ATIVIDADES.CRIAR_COMUNICADO;
    }
  }

  async openUsuariosMultiplanModalAd() {
    let loading = await this.loadingController.create({
      message: 'Carregando usuários...',
    });

    loading.present();

    this.usuarioMultiplanProvider
      .getMultiplanUsers({
        operacao: 'aprovadores_comunicacao_page',
        rowsPerPage: 100,
        idModulo: APIService.MODULOS.Comunicação,
        idAtividade: this.tipoAtividade,
        shopping: this.shopping_selecionado,
      })
      .then(async (result) => {
        this.usuariosAd = result.data;
        let usu = APIService.UsuarioLogado.Usuario.email

        let lista: Array<SelectSearchableItemPaginateApi> = this.usuariosAd.map(
          (user) => user.email != usu ? new SelectSearchableItemPaginateApi(user) : null
        )
        .filter(x => x);
        let listaFiltro: Array<SelectSearchableItemPaginateApi> = [];

        if(this.aprovador_selecionado_data)
        {
          listaFiltro.push(new SelectSearchableItemPaginateApi({...this.aprovador_selecionado_data
          }));
        }

        const modal = await this.modalCtrl.create({
          component: SelectSearchablePageApi,
          componentProps: {
            titulo: 'Usuários Multiplan',
            filtro: '',
            lista: lista,
            maxsize: 1,
            selecionados: listaFiltro,
            provider: this.usuarioMultiplanProvider,
            operacao: 'aprovadores_comunicacao_page',
            idModulo: APIService.MODULOS.Comunicação,
            idAtividade: this.tipoAtividade,
            shopping: this.shopping_selecionado
          },
          cssClass: 'outlineModal',
          backdropDismiss: false,
        });

        modal.onDidDismiss().then((ret) => {
          if (ret.data && ret.data.salvar) {
            // //console.log('selecionados: ', ret.data.selecionados);

            if (ret.data.selecionados.length > 0) {
              for (let i = 0; i < ret.data.selecionados.length; i++) {
                let usuario = {
                  value: ret.data.selecionados[i].user.login1,
                  texto: ret.data.selecionados[i].user.nomUsuario,
                };

                this.form_cadastro.controls['aprovador_selecionado'].setValue(usuario.value);

                this.aprovador_selecionado = usuario.texto;
                this.aprovador_selecionado_data = ret.data.selecionados[i].user;
              }
            } else {
            }
          }
        });

        //load.dismiss();
        await modal.present();
      })
      .finally(() => {
        loading.dismiss();
      });
  }

  validateAllFormFields(formGroup: FormGroup) {
    //{1}
    Object.keys(formGroup.controls).forEach((field) => {
      //{2}
      const control = formGroup.get(field); //{3}
      if (control instanceof FormControl) {
        //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        //{5}
        this.validateAllFormFields(control); //{6}
      }
    });
  }

  dismiss(data = {}) {
    this.modalCtrl.dismiss(data);
  }

  hasSent(date: string | Date | number){
    if(!this.comunicacaoApiResponse?.flgAprovado)
      return false;

    let approvalDate = this.comunicacaoApiResponse.dataConclusao;
    approvalDate = approvalDate instanceof Date ? approvalDate : new Date(approvalDate);

    if(typeof date == 'string' && !date.includes('T'))
      date += 'T00:00:00';
    date = date instanceof Date ? date : new Date(date);

    if(isNaN(date.getTime()) || isNaN(approvalDate.getTime()))
      return false;

    let currentDate = new Date(this.currentDate + 'T00:00:00');
    return (isBefore(date, currentDate) || isSameDay(date, currentDate)) && (isBefore(date, approvalDate) || isSameDay(approvalDate, date));
  }
  async showIAAlert() {
    const alert = await this.AlertController.create({
      header: 'Confirmação',
      message: 'Deseja enviar sem utilizar a revisão de IA?',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            
          },
        },
        {
          text: 'Confirmar',
          role: 'confirm',
          handler: () => {
            
          },
        },
      ],
    });

    await alert.present();
  }


}
